const careerResources = {
  en: {
    career: {
      title: 'Vacancies',
      text1:
        'Dear applicant, please send your CV to the following email address: HR-info@jgarant.kz',
      text2:
        'When sending a resume, it is necessary to write the name of the vacancy in the subject. Open vacancies are also posted on ',
      text3:
        'Future colleague, let me briefly tell you about the culture of Alatau City Garant.',
      text4:
        'In 2005, at a meeting on the development of the Ford Motor Company, the famous economist and publicist Peter Drucker uttered the phrase that has become a catch phrase: "Corporate culture eats strategy for breakfast" (Culture eats strategy for breakfast).',
      text5:
        'This means that employees are the main capital of the Company, and the corporate culture created by employees is a powerful engine that develops and promotes the Company / brand.',
      text6:
        'Therefore, we are scrupulous about our Corporate culture and attention is paid to EACH member of the Team. We value honesty, goodwill, the desire to grow above ourselves, professionalism and the ability to work in a team.',
      text7: 'Well-being',
      text8:
        'The Company is actively promoting the Well-being approach, creating an environment that allows employees to realize their potential for the benefit of themselves and the Company!',
      text9:
        'The rating of the Staff Satisfaction Index is calculated annually, which is constantly growing!',
      text10:
        'In order to strengthen the corporate culture and strengthen health care, competitions, contests and quizzes are held among employees and their children/grandchildren.',
      text11:
        'The staff has a business coach, a professional certified coach with the right to develop and conduct training sessions.',
      text12:
        'The head office has a corporate football team and a fitness space (horizontal bars, exercise bike, table tennis table).',
      text13:
        'And together we pay attention to ESG (Ecology, Society, Leadership).',
      text14: 'Environmental protection',
      text15: 'transition to electronic document management (EDM);',
      text16:
        'meetings, meetings are held using laptops and a projector to minimize the printing of handouts;',
      text17:
        'energy saving - low-power LED lamps are used and the lights in the offices/office are turned off when there are no working workers;',
      text18:
        'automation of air conditioning and ventilation systems is being implemented in large offices, which allows reducing electricity consumption;',
      text19:
        'when leaving for nature, garbage is cleaned - upon arrival at the territory and upon departure.',
      text20: 'Charity',
      text21:
        'Equipment in working condition and new office equipment/office equipment donated to the orphanage,',
      text22:
        'Sponsorship by means of prizes-merchandise of an event supporting traditions and culture, providing education to young people, for example, the "Burymdy Kyz" competition,',
      text23:
        'New Year\'s Program "Letters from Santa Claus" - gifts were given to families with children with disabilities and with a low standard of living and financial assistance was provided privately. The contacts of the families were received from the Office of the Commissioner for Children\'s Rights in the Republic of Kazakhstan (https://bala-ombudsman.kz /).',
      text24:
        'By becoming a part of our Team, you will be able to realize yourself as a professional and be a happy, harmonious person.',
    },
  },
  kz: {
    career: {
      title: 'Вакансиялар',
      text1:
        'Құрметті ізденуші түйіндемеңізді: HR-info@jgarant.kz электрондық мекенжайға жіберіңіз',
      text2:
        'Түйіндемені жіберген кезде, тақырыбында вакансия атауын жазуыңызды сұраймыз. Сондай-ақ, ашық вакансиялар ',
      text3:
        'Болашақ әріптес, Alatau City Garant мәдениеті туралы қысқаша мәлімет берейік.',
      text4:
        '2005 жылы Ford Motor Company компаниясының даму жөніндегі отырысында танымал экономист және публицист Питер Друкер «Корпоративтік мәдениет стратегияны таңғы асқа жейді» деген қанатты сөйлем айтты (Culture eats strategy for breakfast).',
      text5:
        'Бұл дегеніміз, қызметкерлер - Компанияның негізгі капиталы болып табылады, ал қызметкерлер құрған корпоративті мәдениет Компанияны/брендті дамытатын және насихаттайтын қуатты қозғалтқыш болып табылады.',
      text6:
        'Сондықтан біз Корпоративтік мәдениетімізге мұқият қараймыз және команданың ӘРБІР мүшесіне назар аударамыз. Біз адамдардағы адалдықты, ізгі ниетті, өз-өзін өсіруге деген ұмтылысты, кәсіпқойлықты және Командада жұмыс істей білуді бағалаймыз.',
      text7: 'Well-being',
      text8:
        'Компанияда Well-being тәсілдемесі белсенді түрде ілгерілеуде, бұл   қызметкерге өзінің және Компанияның игілігі үшін өз әлеуетін іске асыруға мүмкіндік беретін орта құру!',
      text9:
        'Жыл сайын  үнемі өсіп келе жатқан, персоналдың қанағаттану Индексінің рейтингі есептеледі!',
      text10:
        'Корпоративтік  мәдениетті нығайту және денсаулыққа қамқорлықты күшейту мақсатында қызметкерлер арасында жарыстар, байқаулар мен викториналар өткізіледі.',
      text11:
        'Штатта  бизнес-жаттықтырушы, оқыту тренингтерін әзірлеу және өткізу құқығы бар кәсіби сертификатталған коуч-жаттықтырушы бар.',
      text12:
        'Бас кеңседе корпоративтік футбол командасы және фитнес кеңістігі (турниктер, велотренажерлер, үстел теннисіне арналған үстел) бар.',
      text13: 'Және біз бірге ESG (Экология, Социум, Басшылық) көңіл бөлеміз',
      text14: 'Қоршаған ортаны қорғау',
      text15: 'электрондық құжат айналымға (ЭҚА) көшу;',
      text16:
        'кездесулер, жиналыстар үлестірме материалдарды басып шығаруды азайту үшін ноутбуктер мен проектордың көмегімен өткізіледі;',
      text17:
        'электр. энергияны үнемдеу – энегия тұтыну қуаты төмен жарықдиодты шамдар пайдаланылады және жұмыс істеп жатқан қызметкерлер болмағанда, кабинеттерде/кеңселерде жарық өшіріледі;',
      text18:
        'ірі кеңселерде ауаны баптау және желдету жүйелерін автоматтандыру енгізілуде, бұл электр энергиясын тұтынуды азайтуға мүмкіндік береді;',
      text19:
        'табиғатқа шыққанда – аумаққа келгенде және кетер кезде қоқысты жинау жүргізіледі;',
      text20: 'Қайырымдылық',
      text21:
        'жұмыс күйдегі және жаңа кеңсе техникасы/ кеңсе жабдығы балалар үйіне сыйға тартылды.',
      text22:
        'жастарға тәрбие беретін, салт-дәстүр мен мәдениетті қолдайтын іс-шараларға мерч-сыйлықтар беру арқылы демеушілік жасау, мысалы, «Бұрымды қыз» байқауы',
      text23:
        '«Аяз Ата» жаңа жылдық бағдарламасы -мүмкіндігі шектеулі және өмір сүру деңгейі төмен балалары бар отбасыларға сыйлықтар беріліп, Аяз Атадан келген хаттармен жеке қаржылық көмек көрсетілді. Отбасылардың мекенжайы ҚР-дағы бала құқықтары жөніндегі Уәкілдің Кеңсесінен алынды (https://bala-ombudsman.kz/)',
      text24:
        'Біздің Команданың  бір бөлігі бола отырып, Сіз өзіңізді кәсіби маман ретінде жүзеге асыра аласыз және бақытты, үйлесімді адам бола аласыз.',
    },
  },
  ru: {
    career: {
      title: 'Вакансии',
      text1:
        'Уважаемый соискатель, отправьте, пожалуйста, свое резюме на электронный адрес: HR-info@jgarant.kz',
      text2:
        'При отправке резюме, в теме необходимо написать наименование вакансии. Открытые вакансии также размещены на ',
      text3:
        'Будущий коллега, позвольте вкратце рассказать о культуре Alatau City Garant.',
      text4:
        'В 2005 г. на заседании по развитию компании Ford Motor Company известный экономист и публицист Питер Друкер произнес ставшую крылатой фразу: «Корпоративная культура съедает стратегию на завтрак» (Culture eats strategy for breakfast).',
      text5:
        'Это значит, что работники – основной капитал Компании, и корпоративная культура, создаваемая работниками, является мощным мотором, развивающим и продвигающим Компанию/бренд.',
      text6:
        'Поэтому мы скрупулёзно относимся к нашей Корпоративной культуре и внимание уделяется КАЖДОМУ члену Команды. Мы ценим в людях честность, доброжелательность, стремление расти над собой, профессионализм и умение работать в Команде.',
      text7: 'Well-being',
      text8:
        'В Компании активно продвигается подход Well-being, создание среды, позволяющей сотруднику реализовать свой потенциал на благо себя и Компании!',
      text9:
        'Ежегодно рассчитывается рейтинг Индекса удовлетворённости персонала, который постоянно растет!',
      text10:
        'С целью укрепления корпоративной культуры и усиления заботы о здоровье проводятся соревнования, конкурсы и викторины среди работников и их детей/внуков.',
      text11:
        'В штате есть бизнес-тренер, профессиональный сертифицированный коуч с правом разрабатывать и проводить обучающие тренинги.',
      text12:
        'В головном офисе есть корпоративная футбольная команда и имеется фитнес-пространство (турники, велотренажер, стол для настольного тенниса).',
      text13:
        'И вместе мы уделяем внимание ESG (Экология, Социум, Руководство).',
      text14: 'Защита окружающей среды',
      text15: 'переход на электронный документооборот (ЭДО);',
      text16:
        'встречи, собрания проводятся с использованием ноутбуков и проектора для минимизации распечатки раздаточных материалов;',
      text17:
        'экономия электроэнергии - используются светодиодные лампы с низким энергопотреблением и выключается свет в кабинетах/офисе, когда нет работающих работников;',
      text18:
        'в крупных офисах внедряется автоматизация систем кондиционирования и вентиляции воздуха, что позволяет сокращать потребление электроэнергии;',
      text19:
        'при выезде на природу производится уборка мусора - при прибытии на территорию и при выезде.',
      text20: 'Благотворительность',
      text21:
        'Оборудование в рабочем состоянии и новая орг.техника/офисное оборудование переданы в дар детскому дому,',
      text22:
        'Спонсорство посредством призов-мерчей мероприятия, поддерживающего традиции и культуру, оказывающее воспитание молодежи, например, конкурс «Бұрымды қыз»,',
      text23:
        'Новогодняя Программа «Письма от Деда Мороза» - семьям с детьми с ограниченными возможностями и с низким уровнем жизни переданы подарки и оказана финансовая помощь в частном порядке. Контакты семей были получены от Офиса Уполномоченного по правам ребенка в РК (https://bala-ombudsman.kz/).',
      text24:
        'Став частью нашей Команды, Вы сможете реализовать себя как профессионал и быть счастливым, гармоничным человеком.',
    },
  },
};

export default careerResources;
